export default __webpack_public_path__ + "static/media/mobile_welcome_grid.eee428ee.png";